import React from 'react';

import type { OfflineProps } from '../../types';

/**
 * Offline state view — shown when the application loses connection to the server.
 * Displays a message and a "Try again" button that resets the view to 'init'.
 *
 * @param props.setView - Callback to change the application view state
 */
export const Offline: React.FC<OfflineProps & { setView: (view: string) => void }> = ({
  setView,
}) => {
  return (
    <div>
      <p>Offline</p>
      <hr />
      <div>The application is currently offline</div>
      <hr />
      <button onClick={() => setView('init')}>Try again</button>
    </div>
  );
};
